export default {"src":"/_next/static/media/pinActive.95c6ac93.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};